// Catálogo de mapas base soportados. Una sola fuente de verdad para editor + viewer.
import type maplibregl from 'maplibre-gl';

export type BaseMapId = 'osm-positron' | 'osm-standard' | 'satellite' | 'carto-dark' | 'none';

export const BASE_MAPS: { id: BaseMapId; label: string; light: boolean }[] = [
  { id: 'osm-positron',  label: 'Positron (claro)',  light: true  },
  { id: 'osm-standard',  label: 'OSM estándar',      light: true  },
  { id: 'satellite',     label: 'Satélite',          light: false },
  { id: 'carto-dark',    label: 'Carto Dark',        light: false },
  { id: 'none',          label: 'Sin fondo',         light: true  },
];

type RasterSource = Extract<maplibregl.SourceSpecification, { type: 'raster' }>;

// Devuelve la source raster correspondiente, o null si "none".
export function baseMapSource(id: BaseMapId): RasterSource | null {
  switch (id) {
    case 'osm-positron':
      return {
        type: 'raster',
        tiles: [
          'https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          'https://b.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
          'https://c.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
        ],
        tileSize: 256,
        attribution: '© OpenStreetMap, © CARTO',
      };
    case 'osm-standard':
      return {
        type: 'raster',
        tiles: ['https://tile.openstreetmap.org/{z}/{x}/{y}.png'],
        tileSize: 256,
        attribution: '© OpenStreetMap',
      };
    case 'satellite':
      return {
        type: 'raster',
        tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
        tileSize: 256,
        attribution: '© Esri World Imagery',
      };
    case 'carto-dark':
      return {
        type: 'raster',
        tiles: [
          'https://a.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
          'https://b.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
          'https://c.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
        ],
        tileSize: 256,
        attribution: '© OpenStreetMap, © CARTO',
      };
    case 'none':
      return null;
  }
}

export function safeBaseMapId(s: string | null | undefined): BaseMapId {
  return BASE_MAPS.some(b => b.id === s) ? (s as BaseMapId) : 'osm-positron';
}
